const permissions = () => {
  const user = JSON.parse(localStorage.getItem('userData'))
  const defaultPermission = 'ROLE_CORE_CONSULTAR'
  if (user && user.role === 'PROFISSIONAL') {
    return 'ROLE_SUPER_USER'
  }
  return defaultPermission
}

const menu = [
  {
    header: "Settings",
    action: permissions(),
    resource: "ACL",
  },
  {
    title: "Register",
    icon: "UserCheckIcon",
    action: "ROLE_ADMIM_CONSULTAR",
    resource: "ACL",
    children: [
      {
        title: "Administrative",
        route: "administrativeSettings",
        action: "ROLE_ADMIM_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Atendimento",
        route: "attendanceSettings",
        action: "ROLE_ATEND_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Events",
        route: "event",
        action: "ROLE_EVENTO_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Financial",
        route: "financialSettings",
        action: "ROLE_FINAN_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Moedas",
        route: "moedaSettings",
        action: "ROLE_FINAN_CONSULTAR",
        resource: "ACL",
        icon: "DollarSignIcon",
      },
      {
        title: "Protocolo",
        route: "protocolSettings",
        action: "ROLE_PROT_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Orders de Serviços",
        route: "ordemServicoSettings",
        action: "ROLE_ORD_CONSULTAR",
        resource: "ACL",
      },
    ],
  },
  {
    title: "Configurações",
    icon: "ToolIcon",
    action: "ROLE_SUPER_USER",
    resource: "ACL",
    children: [
      {
        title: "Cliente",
        route: "settings-client",
        action: "ROLE_SUPER_USER",
        resource: "ACL",
      },
      {
        title: "Diretoria",
        route: "settings-diretoria",
        action: "ROLE_SUPER_USER",
        resource: "ACL",
      },
    ],
  },
  {
    title: 'Auditoria',
    icon: 'ShieldIcon',
    action: 'ROLE_SUPER_USER',
    resource: 'ACL',
    children: [
      {
        title: 'Logs',
        route: 'audit-logs',
        action: 'ROLE_SUPER_USER',
        resource: 'ACL',
      },
    ],
  },
  {
    title: "Access",
    icon: "UserIcon",
    action: "ROLE_CORE_CONSULTAR",
    resource: "ACL",
    children: [
      {
        title: "Users",
        route: "usersSettings",
        action: "ROLE_SUPER_USER",
        resource: "ACL",
      },
      {
        title: "Profile",
        route: "profileSettings",
        action: "ROLE_PERFIL_CONSULTAR",
        resource: "ACL",
      },
    ],
  },
];

export default menu;
